import { Link as RouterLink } from 'react-router-dom';
import { textStyleCss } from 'src/theme/atlas';
import styled, { css } from 'styled-components';

export type StyledLinkProps = {
  size?: 'small' | 'medium' | 'large';
  state?: 'default' | 'disabled';
  color?: string;
};

const sharedStyle = css<StyledLinkProps>`
  ${({ theme }) =>
    theme.isVaultVariant
      ? 'text-decoration: none;'
      : 'text-decoration: underline;'}
  ${(props) => {
    switch (props.size) {
      case 'large':
        return textStyleCss(props.theme.atlas.typography.semantic.body);
      case 'medium':
        return textStyleCss(props.theme.atlas.typography.semantic.bodySmall);
      case 'small':
        return textStyleCss(props.theme.atlas.typography.semantic.caption);
      default:
        return textStyleCss(props.theme.atlas.typography.semantic.caption);
    }
  }}
  ${(props) => {
    switch (props.state) {
      case 'disabled':
        return `
          color: ${props.theme.atlas.semantic.color.type.disabled};
          cursor: not-allowed;
        `;
      case 'default':
        return `
            color: ${
              props.color
                ? props.color
                : props.theme.atlas.semantic.color.action.link.default
            };
            cursor: pointer;
            &:hover {
              ${props.theme.isVaultVariant ? 'text-decoration: underline;' : ''}
              color: ${props.theme.atlas.semantic.color.action.link.hover};
            }
          `;
      default:
        return `
          color: ${
            props.color
              ? props.color
              : props.theme.atlas.semantic.color.action.link.default
          };
          cursor: pointer;
          &:hover {
            ${props.theme.isVaultVariant ? 'text-decoration: underline;' : ''}
            color: ${props.theme.atlas.semantic.color.action.link.hover};
          }
        `;
    }
  }}
`;

export const StyledRouterLink = styled(RouterLink)<StyledLinkProps>`
  ${sharedStyle}
`;

export const StyledLink = styled.a<StyledLinkProps>`
  ${sharedStyle}
`;
